import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import EntityId = com.eidu.sharedlib.entity.EntityId

type PublishEntityParameters = {
  id: EntityId
  compatibility?: Record<string, string>
}

export type PublishEntityResponse = {
  versionId: string
  snapshotResourceKey: string
  logId: string
}

const publishEntity = async ({ id, compatibility = {} }: PublishEntityParameters): Promise<PublishEntityResponse> => {
  const response = await fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/entities/${id.toString()}/publish`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ compatibility }),
    }
  )
  if (response.status !== 200) throw Error(`Unexpected response code ${response.status} from publishEntity endpoint`)
  return (await response.json()) as PublishEntityResponse
}

export default publishEntity
